import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import H5Layout from './layout/H5Layout';
import H5HomePage from './pages/H5HomePage';
import H5EssayWizard from './pages/H5EssayWizard';
import H5HistoryPage from './pages/H5HistoryPage';
import H5ResultPage from './pages/H5ResultPage';
import H5ProfilePage from './pages/H5ProfilePage';
import './styles/h5.css';

interface H5AppProps {
  onLogout: () => void;
}

const H5App: React.FC<H5AppProps> = ({ onLogout }) => {
  return (
    <H5Layout onLogout={onLogout}>
      <Routes>
        <Route path="/h5" element={<H5HomePage />} />
        <Route path="/h5/essay/new" element={<H5EssayWizard />} />
        <Route path="/h5/history" element={<H5HistoryPage />} />
        <Route path="/h5/essay/:essayId/result" element={<H5ResultPage />} />
        <Route path="/h5/profile" element={<H5ProfilePage onLogout={onLogout} />} />
        <Route path="/h5/*" element={<Navigate to="/h5" replace />} />
      </Routes>
    </H5Layout>
  );
};

export default H5App;
